if (!customElements.get('ct-cart')) {
  customElements.define('ct-cart', class extends HTMLElement {
    connectedCallback() {
      this.inner = this.closest('.drawer__inner');
      this.querySelectorAll('[data-qty]').forEach((b) => b.addEventListener('click', () => this.change({ line: parseInt(b.closest('[data-line]').dataset.line, 10), quantity: parseInt(b.dataset.qty, 10) })));
      const prot = this.querySelector('[data-prot]');
      if (prot) prot.addEventListener('change', () => {
        if (prot.checked) this.post('cart/add.js', { items: [{ id: parseInt(this.dataset.protVariant, 10), quantity: 1 }] });
        else this.change({ id: String(this.dataset.protVariant), quantity: 0 });
      });
      const code = this.querySelector('[data-code]');
      if (code) code.addEventListener('submit', (e) => {
        e.preventDefault();
        const v = (code.code.value || '').trim();
        if (!v) return;
        const current = Array.from(this.querySelectorAll('[data-code-tag]')).map((t) => t.dataset.codeTag);
        this.wantedCode = v;
        this.post('cart/update.js', { discount: current.concat(v).join(',') });
      });
      this.querySelectorAll('[data-rm-code]').forEach((b) => b.addEventListener('click', () => {
        const keep = Array.from(this.querySelectorAll('[data-code-tag]')).map((t) => t.dataset.codeTag).filter((c) => c !== b.dataset.rmCode);
        this.post('cart/update.js', { discount: keep.join(',') });
      }));
      if (this.dataset.orphan === 'true') this.change({ id: String(this.dataset.protVariant), quantity: 0 });
      if (this.dataset.msg) this.error(this.dataset.msg);
    }
    change(body) { this.post('cart/change.js', body); }
    async post(path, body) {
      if (this.inner) this.inner.classList.add('is-busy');
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const res = await fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const data = await res.json();
        if (data.status && data.description) { this.error(data.description); return; }
        let msg = '';
        if (this.wantedCode && Array.isArray(data.discount_codes)) {
          const want = this.wantedCode.toLowerCase();
          const hit = data.discount_codes.find((d) => String(d.code).toLowerCase() === want);
          if (!hit || !hit.applicable) msg = 'Ce code promo n’est pas valable pour ce panier.';
        }
        this.render(data, msg);
      } catch (e) {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      } finally {
        if (this.inner) this.inner.classList.remove('is-busy');
      }
    }
    render(data, msg) {
      const sections = data.sections || {};
      const drawer = this.closest('cart-drawer');
      if (sections['cart-drawer']) {
        const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const src = doc.querySelector('#CartDrawer');
        const dst = document.getElementById('CartDrawer');
        if (src && dst) {
          if (msg) { const app = src.querySelector('ct-cart'); if (app) app.setAttribute('data-msg', msg); }
          dst.innerHTML = src.innerHTML;
          const empty = !!dst.querySelector('.ct-cd__empty');
          if (drawer) {
            drawer.classList.toggle('is-empty', empty);
            const ov = dst.querySelector('#CartDrawer-Overlay');
            if (ov) ov.addEventListener('click', () => drawer.close());
          }
        }
      }
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        const b = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (b) bubble.innerHTML = b.innerHTML;
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ct-cart', cartData: data });
    }
    error(text) {
      const el = this.querySelector('[data-err]');
      if (el) { el.textContent = text; el.hidden = false; }
    }
  });
}